import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Card mostrado quando o usuário ganha pontos por uma ação — post, curtida,
 * bônus diário, cadastro. Distinto de `PointsManualNotification`, que é o
 * ajuste feito por um admin e tem um remetente humano no card.
 *
 * O `reason` vem do backend já restrito ao allowlist de
 * `PointsEarnedBlueprint::REASONS` (fora dele vira `other`), então mapear
 * motivo → chave de tradução aqui é seguro: nenhum valor arbitrário chega
 * a virar chave.
 */

const ICONS = {
  'discussion.started': 'fas fa-comments',
  'post.posted': 'fas fa-reply',
  'like.received': 'fas fa-heart',
  'like.given': 'fas fa-thumbs-up',
  'user.daily_login': 'fas fa-calendar-check',
  'user.registered': 'fas fa-user-plus'
};

/** Motivo → sufixo da chave de tradução (`notifications.earned_*`). */
const KEYS = {
  'discussion.started': 'discussion',
  'post.posted': 'post',
  'like.received': 'like_received',
  'like.given': 'like_given',
  'user.daily_login': 'daily_login',
  'user.registered': 'registered'
};
export default class PointsEarnedNotification extends Notification {
  data() {
    var _notification, _notification$content, _raw$amount, _raw$reason;
    const raw = ((_notification = this.attrs.notification) == null || (_notification$content = _notification.content) == null ? void 0 : _notification$content.call(_notification)) || {};
    const amount = Number((_raw$amount = raw == null ? void 0 : raw.amount) != null ? _raw$amount : 0);
    return {
      amount: Number.isFinite(amount) ? amount : 0,
      reason: String((_raw$reason = raw == null ? void 0 : raw.reason) != null ? _raw$reason : 'other')
    };
  }
  icon() {
    var _ICONS$this$data$reas;
    return (_ICONS$this$data$reas = ICONS[this.data().reason]) != null ? _ICONS$this$data$reas : app.forum.attribute('pointSystem.currency_icon') || 'fas fa-coins';
  }
  href() {
    // Leva à loja: o usuário acabou de ganhar saldo, o passo seguinte
    // natural é ver no que gastar.
    try {
      return app.route('pointSystem.shop');
    } catch (_unused) {
      return '/';
    }
  }

  /**
   * Abstrato no core, então precisa existir mesmo devolvendo nada: o card
   * do ganho já diz tudo em uma linha e um excerto repetiria a mesma frase.
   */
  excerpt() {
    return null;
  }
  content() {
    var _KEYS$reason;
    const _this$data = this.data(),
      amount = _this$data.amount,
      reason = _this$data.reason;
    const suffix = (_KEYS$reason = KEYS[reason]) != null ? _KEYS$reason : 'other';
    return app.translator.trans('ramon-point-system.forum.notifications.earned_' + suffix, {
      amount: amount.toLocaleString()
    });
  }
}
flarum.reg.add('ramon-point-system', 'forum/components/PointsEarnedNotification', PointsEarnedNotification);